export const ApiEndPoints = {
  login: "/api/login",
  hospitalLogin: "/api/hospitalLogin",
  forgotPassword: "/api/users/updatePassword",
  users: "/api/users",
  addUsers: "/api/users/add",
  updateUsers: "/api/users/update",
  getRoles: "/api/roles",
  getDesignations: "/api/designations/",
  taluks: "/api/taluks",
  phcs: "/api/phcs",
  getPhcByTalukId: "/api/phcs/byTalukId/",
  ashaBlocks: "/api/ashaBlocks",
  ashas: "/api/ashas",
  getAshaBlockByTalukId: "/api/ashaBlocks/byTalukId/",
  getAshaBlockByPhcId: "/api/ashaBlocks/byPhcId/",
  getAshaBlockById: "/api/ashaBlocks/id/",
  getAshaByAshaBlockId: "/api/ashas/byAshaBlockId/",
  getAshaByTalukId: "/api/ashas/byTalukId/",
  getAshaByPhcId: "/api/ashas/byPhcId/",
  getAshaDailyReport: "/api/ashas/dailyReport",
  getAshaDailyReportByDateRange: "/api/ashas/dailyReportByDateRange",
  hospitals: "/api/hospitals",
  getHospitalById: "/api/hospitals/id",
  ssMembers: "/api/ssm",
  getSsMembersById: "/api/ssm/id",
  camps: "/api/ssc",
  followupPlaces: "/api/followupPlace",
  patients: "/api/patients",
  getPatientsByHospital: "/api/patients/hospital",
  getPatientDetails: "/api/patients/details",
  patientCataractDetails: "/api/cataract",
  patientGlaucomaDetails: "/api/glaucoma",
  patientDiabeticRetinopathyDetails: "/api/dr",
  getAshaAbstractReport: "/api/asha-abstract-reports",
};
